import $http from '@/resource';
import utils from '@/utils';
import {Message, Notice} from 'view-design';

const $api = {};

/**
 * 单位管理员
 * 
 * @param {Object} data 表单数据
 *
 * @returns {Promise<any>}
 */
$api.changePassword = (data) => {
	const url = 'password';
	const promise = new Promise(function(resolve, reject){
		$http.put(url, data).then(function (response) {
		  	if (response.code == 200) {
		  		resolve(response.msg);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  		reject();
		  	}
		});
	});
  	return promise;
}


export default $api; 


// WEBPACK FOOTER //
// ./src/service/usercenter/password.js